import Dribbble from '@/components/SvgIcons/Socials/Dribbble';
import Facebook from '@/components/SvgIcons/Socials/Facebook';
import Instagram from '@/components/SvgIcons/Socials/Instagram';
import LinkedIn from '@/components/SvgIcons/Socials/LinkedIn';
import X from '@/components/SvgIcons/Socials/X';
import Youtube from '@/components/SvgIcons/Socials/Youtube';
import { SocialProfile } from '@/types/profile.type';

export const socialProfiles: SocialProfile[] = [
  { name: 'Facebook', href: 'https://www.facebook.com/workspacedigitalstudio', icon: Facebook },
  { name: 'Instagram', href: 'https://www.instagram.com/workspace.hr/', icon: Instagram },
  { name: 'X', href: 'https://x.com/workspace_hr', icon: X },
  { name: 'YouTube', href: 'https://www.youtube.com/@workspace-hr', icon: Youtube },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/workspace-hr/', icon: LinkedIn },
  { name: 'Dribbble', href: 'https://dribbble.com/workspace-hr', icon: Dribbble },
];
